import { render, staticRenderFns } from "./GlobalChatbotContainer.vue?vue&type=template&id=1bbe0502&scoped=true"
import script from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
export * from "./GlobalChatbotContainer.vue?vue&type=script&lang=js"
import style0 from "./GlobalChatbotContainer.vue?vue&type=style&index=0&id=1bbe0502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe0502",
  null
  
)

export default component.exports